import { Box } from '@mui/material';
import React, { FC } from 'react';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoanFormType } from 'views/orders/loans/types';

import { OptionalChoiceForm } from '../optional-choice-form';

type Props = {
  control: Control<LoanFormType, object>;
  setValue: UseFormSetValue<LoanFormType>;
  isDataLoading: boolean;
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const EscrowAccountForm: FC<Props> = ({ control, setValue, isDataLoading, onSave }) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="escrow"
      render={({ field }) => (
        <Box display="flex" flexDirection="column" flex={1}>
          <OptionalChoiceForm
            onBlur={() => { onSave(); }}
            title={t('loanDisclosures:escrow-account')}
            description={t('loanDisclosures:escrow-account-subtitle')}
            value={field.value}
            options={[
              {
                label: t('loanDisclosures:escrow-account-option-1'),
                disabled: isDataLoading,
                value: true
              },
              {
                label: t('loanDisclosures:escrow-account-option-2'),
                disabled: isDataLoading,
                value: false
              }
            ]}
            onChange={(value) => {
              if (value === true) {
                setValue('escrow_declined', null);
                field.onChange(true);
              } else if (value === null) {
                setValue('escrow_declined', null);
                field.onChange(null);
              } else {
                field.onChange(false);
              }
              onSave();
            }}
          />
          {field.value === false && (
            <Controller
              control={control}
              name="escrow_declined"
              render={({ field: escrowDeclinedField }) => (
                <OptionalChoiceForm
                  onBlur={() => { onSave(); }}
                  description={t('loanDisclosures:escrow-account-subtitle-will-not')}
                  value={escrowDeclinedField.value}
                  options={[
                    {
                      label: t('loanDisclosures:escrow-account-option-1-will-not'),
                      disabled: isDataLoading,
                      value: true
                    },
                    {
                      label: t('loanDisclosures:escrow-account-option-2-will-not'),
                      disabled: isDataLoading,
                      value: false
                    }
                  ]}
                  onChange={(value) => { escrowDeclinedField.onChange(value); onSave(); }}
                />
              )}
            />
          )}
        </Box>
      )}
    />
  );
};
